<script setup lang="ts">
defineProps<{ isLoading: boolean }>();

const skeletonVariant = 'white';
</script>

<template>
	<div
		class="flex flex-col items-start justify-end gap-px bg-white px-5 pb-8 md:gap-5 md:self-stretch lg:gap-px lg:px-0 lg:flex-row lg:items-center lg:justify-between xl:flex-col xl:items-start xl:justify-end"
	>
		<div class="pb-4 pt-5 md:pt-9 lg:pb-0 lg:pt-5 xl:pb-4">
			<Skeleton
				:is-active="isLoading"
				class="h-[45px] w-[200px]"
				:variant="skeletonVariant"
			/>
		</div>

		<div class="flex justify-end lg:shrink-0 xl:shrink">
			<div class="flex w-full flex-nowrap items-center">
				<div
					v-for="index in 2"
					:key="`property-highlighted-infos-skeleton-${index}`"
					class="flex flex-1 items-center"
				>
					<div
						class="flex w-full items-center justify-end gap-1 whitespace-nowrap"
					>
						<Skeleton
							:is-active="isLoading"
							class="h-[18px]"
							:class="index % 2 ? 'w-[120px]' : 'w-[80px]'"
							:variant="skeletonVariant"
						/>
						<Skeleton
							:is-active="isLoading"
							class="h-[18px]"
							:class="index % 2 ? 'w-[80px]' : 'w-[100px]'"
							:variant="skeletonVariant"
						/>
					</div>

					<div
						v-if="index < 1"
						class="mx-2 size-1 shrink-0 rounded-none bg-beige"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>
